import { Paper, Grid } from '@mui/material';
import Box from '@mui/material/Box';
import { links } from '../utils/links';
import { icons } from '../utils/icons';
import {useEffect, useState} from "react";
import logo from '../images/logo-white.png';

const Footer = () => {
    const [width, setWindowWidth] = useState(0);

    const responsive = {
        mobileView: width < 720
    }

    useEffect(() => {
        updateDimensions();

        window.addEventListener("resize", updateDimensions);

        return () =>
            window.removeEventListener("resize", updateDimensions);
    })

    const updateDimensions = () => {
        const width = window.innerWidth;
        setWindowWidth(width);
    }

    if (!responsive.mobileView) {
        return (
            <Grid container direction="row" style={{fontFamily: 'Lato'}}>
                <Grid item style={{ width: '100%', minWidth: '100% !important' }}>
                    <Paper style={{ backgroundColor: '#454545', color: '#FFFFFF', height: '100%', paddingBottom: '30px' }}>
                        <Grid container direction="row" style={{ paddingRight: '30px' }}>
                            <Grid item xs={6} lg={5}>
                                <Grid container direction="column" >
                                    <Grid item style={{ marginLeft: '30px' }}>
                                        <Grid container direction="row">
                                            <Grid item>
                                                <img style={{ width: '171px', height: '49px', marginTop: '30px', marginRight: '30px' }} src={logo} alt="logo" />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item style={{ marginTop: '20px', marginLeft: '30px', fontWeight: '700' }}>
                                        <Grid container>
                                            <Grid item>
                                                <Grid container direction="column">
                                                    {links.slice(0, 4).map((link : any, index: any) => {
                                                        return (
                                                            <Grid 
                                                                item 
                                                                style={{ marginBottom: '10px' }}
                                                                key={index}
                                                            >
                                                                <a
                                                                    href={link.url}
                                                                    style={{
                                                                        margin: '0px',
                                                                        textDecoration: 'none',
                                                                        color: 'inherit',
                                                                        fontSize: '14px',
                                                                        marginRight: '40px' }}>
                                                                    {link.title}
                                                                </a>
                                                            </Grid>
                                                        )
                                                    })}
                                                </Grid>
                                            </Grid>
                                            <Grid item>
                                                <Grid container direction="column">
                                                    {links.slice(4, 7).map((link : any,index : any) => {
                                                        return (
                                                            <Grid 
                                                                item 
                                                                style={{ marginBottom: '10px' }}
                                                                key={index}
                                                            >
                                                                <a
                                                                    href={link.url}
                                                                    style={{
                                                                        margin: '0px',
                                                                        color: 'inherit',
                                                                        textDecoration: 'none',
                                                                        fontSize: '14px' }}>
                                                                    {link.title}
                                                                </a>
                                                            </Grid>
                                                        )
                                                    })}
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={6} lg={7} style={{ marginTop: '80px' }}>
                                <Grid container direction="column" >
                                    <Grid item>
                                        <Grid container style={{ marginTop: '20px' }}>
                                            {icons.map((icon : any, index: any) => {
                                                return (
                                                    <Grid 
                                                        item 
                                                        style={{ marginRight: '13px' }}
                                                        key={index}
                                                    >
                                                        <a href={icon.link} >
                                                            <img style={{ height: '33px', width: '33px' }} src={icon.media} alt={icon.alt} />
                                                        </a>
                                                    </Grid>
                                                )
                                            })}
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Grid container alignContent="center">
                                            <Grid item>
                                                <Box display="flex">
                                                    <p style={{ textAlign: 'left', marginTop: '10px', fontSize: '14px' }}>Refunds will not be issued for purchases made during a promotional time-period or for subscriptions renewals. <br /> <br />The services offered by Mutual LLC are neither made, provided, approved nor endorsed by Intellectual Reserve, Inc. or The Church of Jesus Christ of Latter-day Saints.  Any content or opinions expressed, implied or included in or with the services offered by Mutual LLC are solely those of Mutual LLC and not those of Intellectual Reserve, Inc. or The Church of Jesus Christ of Latter-day Saints.</p>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
            </Grid>
        );
    } else {
        return (
            <Grid container direction="row" style={{fontFamily: 'Lato'}}    >
                <Grid item style={{ width: '100%', minWidth: '100% !important' }}>
                    <Paper style={{ backgroundColor: '#454545', color: '#FFFFFF', height: '100%', paddingBottom: '30px', width: '100%' }}>
                        <Grid container direction="column" style={{ paddingRight: '30px' }}>
                            <Grid item xs={6} lg={5}>
                                <Grid container direction="column" >
                                    <Grid item style={{ marginLeft: '30px' }}>
                                        <Grid container direction="row">
                                            <Grid item>
                                                <img style={{ width: '171px', height: '49px', marginTop: '30px', marginRight: '30px' }} src={logo} alt="logo" />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item style={{ marginTop: '20px', marginLeft: '30px', fontWeight: '700' }}>
                                        <Grid container>
                                            <Grid item>
                                                <Grid container direction="column">
                                                    {links.slice(0, 4).map((link : any,index : any) => {
                                                        return (
                                                            <Grid 
                                                                item 
                                                                style={{ marginBottom: '10px' }}
                                                                key={index}
                                                            >
                                                                <a
                                                                    href={link.url}
                                                                    style={{
                                                                        margin: '0px',
                                                                        textDecoration: 'none',
                                                                        color: 'inherit',
                                                                        fontSize: '14px',
                                                                        marginRight: '40px' }}>
                                                                    {link.title}
                                                                </a>
                                                            </Grid>
                                                        )
                                                    })}
                                                </Grid>
                                            </Grid>
                                            <Grid item>
                                                <Grid container direction="column">
                                                    {links.slice(4, 7).map((link : any, index : any) => {
                                                        return (
                                                            <Grid 
                                                                item 
                                                                style={{ marginBottom: '10px' }}
                                                                key={index}
                                                            >
                                                                <a
                                                                    href={link.url}
                                                                    style={{
                                                                        margin: '0px',
                                                                        color: 'inherit',
                                                                        textDecoration: 'none',
                                                                        fontSize: '14px' }}>
                                                                    {link.title}
                                                                </a>
                                                            </Grid>
                                                        )
                                                    })}
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={6} lg={7} style={{ marginTop: '40px', marginLeft: '30px' }}>
                                <Grid container direction="column" >
                                    <Grid item>
                                        <Grid container style={{ marginTop: '20px' }}>
                                            {icons.map((icon : any, index : any) => {
                                                return (
                                                    <Grid 
                                                        item 
                                                        style={{ marginRight: '13px' }}
                                                        key={index}
                                                    >
                                                        <a href={icon.link} >
                                                            <img style={{ height: '33px', width: '33px' }} src={icon.media} alt={icon.alt} />
                                                        </a>
                                                    </Grid>
                                                )
                                            })}
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Grid container alignContent="center">
                                            <Grid item>
                                                <Box display="flex">
                                                    <p style={{ textAlign: 'left', marginTop: '10px', fontSize: '14px' }}>Refunds will not be issued for purchases made during a promotional time-period or for subscriptions renewals. <br /> <br />The services offered by Mutual LLC are neither made, provided, approved nor endorsed by Intellectual Reserve, Inc. or The Church of Jesus Christ of Latter-day Saints.  Any content or opinions expressed, implied or included in or with the services offered by Mutual LLC are solely those of Mutual LLC and not those of Intellectual Reserve, Inc. or The Church of Jesus Christ of Latter-day Saints.</p>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
            </Grid>
        );
    }
}


export default Footer;
